'use client';
import classNames from 'classnames';
import React from 'react';
import { MaterialIconName } from '../../types/materialIconName';
import SectionButton from '../SectionButton';

interface CollapsibleSectionProps {
  id: string;
  isOpen: boolean;
  onToggle: (id: string) => void;
  children: React.ReactNode;
  iconName?: MaterialIconName;
  className?: string;
  buttonClassName?: string;
  contentClassName?: string;
  iconClassName?: string;
  content?: React.ReactNode;
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  id,
  isOpen,
  onToggle,
  children,
  content,
  iconName,
  className = '',
  buttonClassName = '',
  contentClassName = '',
  iconClassName = '',
}) => {
  const handleToggle = () => {
    onToggle(isOpen ? '' : id);
  };

  return (
    <div className={className}>
      <SectionButton
        isOpen={isOpen}
        toggleVisibility={handleToggle}
        iconName={iconName}
        className={buttonClassName}
        iconClassName={iconClassName}
      >
        {children}
      </SectionButton>

      <div
        className={classNames(
          'transition-all duration-200 ease-in-out',
          {
            'visible max-h-fit opacity-100': isOpen,
            'invisible max-h-0 opacity-0 overflow-hidden': !isOpen,
          },
          contentClassName,
        )}
      >
        {content}
      </div>
    </div>
  );
};
